import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';
import { BazaNcPayoffDistributionPaymentSource } from '../models/baza-nc-payoff-distribution-payment-source';
import { BazaNcPayoffDistributionPaymentStatus } from '../models/baza-nc-payoff-distribution-payment-status';
import { OfferingId } from '../../../../transact-api';
import { ulid } from 'ulid';

export class BazaNcPayoffDistributionTransactionEntryCsvDto {
    @ApiModelProperty({
        description: 'ULID (ID)',
        example: ulid(),
    })
    ulid: string;

    @ApiModelProperty({
        description: 'Date Created At',
        example: '12/01/2022',
    })
    dateCreatedAt: string;

    @ApiModelProperty({
        description: 'Date Updated At',
        example: '12/01/2022',
        required: false,
    })
    dateUpdatedAt?: string;

    @ApiModelProperty({
        description: 'Date Processed At',
        example: '12/01/2022',
        required: false,
    })
    dateProcessedAt?: string;

    @ApiModelProperty({
        description: 'Date',
        example: '12/01/2022',
    })
    date: string;

    @ApiModelProperty({
        type: 'string',
        description: 'Payment Source',
        enum: Object.values(BazaNcPayoffDistributionPaymentSource),
    })
    source: BazaNcPayoffDistributionPaymentSource;

    @ApiModelProperty({
        description: 'Investor Account',
    })
    investorAccount: string;

    @ApiModelProperty({
        description: 'Investor Account (NC Account ID)',
    })
    ncAccountId: string;

    @ApiModelProperty({
        description: 'Investor Account (NC Party ID)',
    })
    ncPartyId: string;

    @ApiModelProperty({
        description: 'Amount (as string)',
        example: '50.00',
    })
    amount: string;

    @ApiModelProperty({
        type: 'string',
        description: 'Status',
        enum: Object.values(BazaNcPayoffDistributionPaymentStatus),
        example: BazaNcPayoffDistributionPaymentStatus.Pending,
    })
    status: BazaNcPayoffDistributionPaymentStatus;
}
